// extracted by mini-css-extract-plugin
export default {"productGrid":"_0-z","centerLink":"a1-z","productSection":"b1-z","item":"c1-z","ctaButton":"d1-z"};